import get from 'lodash/get'
import { CREATE_TCA_FAILURE, CREATE_TCA_REQUEST, CREATE_TCA_RESET, CREATE_TCA_SUCCESS } from './actionTypes'

import { createTcaForClient } from '../api/mikasa/requests'
import { CONFIRMED_TCA_REQUEST } from '../constants/client/answers'
import { saveClientAnswer } from './client'

import { asyncDebounce } from '../helpers/asyncDebounce'
import { selectClientId } from '../store/selectors/client'
import { selectHomeUuid } from '../store/selectors/home'
import { getTcaReportKeyFromRefiDetails } from '../store/selectors/tca'

export const createTca = refiData => async (dispatch, getState) => {
  const state = getState()
  const clientId = selectClientId(state)
  const homeId = selectHomeUuid(state)

  dispatch({
    type: CREATE_TCA_REQUEST
  })

  // Hack to fix race condition where we fire off multiple requests to create a TCA for new clients
  // https://homebot.atlassian.net/jira/software/c/projects/SQUAD1/boards/109?modal=detail&selectedIssue=SQUAD1-593
  const debouncedCreateTca = asyncDebounce(createTcaForClient, 1000)

  try {
    const response = await debouncedCreateTca(homeId, clientId, refiData)
    dispatch({
      type: CREATE_TCA_SUCCESS,
      leadTimeHours: get(response, 'data.data.leadTimeHours', 0),
      tcaUpdated: get(response, 'data.data.tcaUpdated', false),
      reportLink: get(response, 'data.data.reportLink', null),
      reportKey: getTcaReportKeyFromRefiDetails(refiData)
    })
  } catch (error) {
    dispatch({
      type: CREATE_TCA_FAILURE,
      error
    })
  }
}

export const resetTca = () => async dispatch => {
  dispatch({
    type: CREATE_TCA_RESET
  })
}

export const clientConfirmTca = () => async dispatch => {
  dispatch(
    saveClientAnswer({
      question: CONFIRMED_TCA_REQUEST,
      response: {
        value: true
      }
    })
  )
}
